import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shop-service",
  "use": "icon-shop-service-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-shop-service\"><defs><style>#icon-shop-service .a{fill:#fff;opacity:0;}#icon-shop-service .b{fill:currentColor;}</style></defs><g transform=\"translate(-335 -51)\"><rect class=\"a\" width=\"30\" height=\"30\" transform=\"translate(335 51)\" /><path class=\"b\" d=\"M164.6,117.76a10.23,10.23,0,1,1-3.122,19.971l-3.36.479c-.274.039-1.222.193-1.222.193s.231-.948.3-1.216l.424-1.7a10.228,10.228,0,0,1,6.957-17.726h.024Zm0,1.661h-.024a8.569,8.569,0,0,0-5.5,15.141.832.832,0,0,1,.273.838l-.247.993,2.33-.334a.836.836,0,0,1,.386.038,8.569,8.569,0,1,0,2.778-16.675Zm-2.369,6.689-.941,3.76h-1.88l.941-3.76h1.879Zm3.759,0-.94,3.76h-1.88l.94-3.76Zm3.76,0-.941,3.76h-1.88l.941-3.76h1.879Z\" transform=\"translate(185.405 -62.76)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/shop-service.svg
// module id = Se3A
// module chunks = 65